import { Link } from 'react-router-dom';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Avatar, Heading3, Paragraph, Spinner, UnderlineLink } from '@treams/treams-ui';

import { useJobTitleName } from '../../../../job/useJobTitleName';
import { useModalLink } from '../../../../navigation/ModalNavigation';
import InboxPersonalCard from './InboxPersonalCard';

function InboxPersonalInformationWithViewer(props: { viewer: graphql.User }) {
	const jobTitleName = useJobTitleName();

	const jobPosition = props.viewer.currentJobPosition;
	const jobTitle = jobTitleName(jobPosition?.jobTitle);

	const link = useModalLink(`/job-positions/${jobPosition?.id}`);

	return (
		<>
			<Avatar user={props.viewer} size={64} />
			<Heading3 mt={2}>
				{props.viewer.firstName} {props.viewer.lastName}
			</Heading3>

			{jobTitle && (
				<Box mt={1}>
					<UnderlineLink as={Link} to={link} color="secondary">
						{jobTitle}
					</UnderlineLink>
				</Box>
			)}
			{props.viewer.mission.length > 0 && <Paragraph>"{props.viewer.mission}"</Paragraph>}
		</>
	);
}

export default function InboxPersonalInformation() {
	const query = graphql.useInboxPersonalInformationQuery();

	return (
		<InboxPersonalCard>
			<Flex p={4} alignItems="center" flexDirection="column">
				{query.data ? (
					<InboxPersonalInformationWithViewer viewer={query.data.viewer as graphql.User} />
				) : (
					<Spinner />
				)}
			</Flex>
		</InboxPersonalCard>
	);
}
